// extracted by mini-css-extract-plugin
export default {"wrapper":"J9","container":"K9","image":"L9","info":"M9","title":"N9","note":"O9","product":"P9","product_img":"Q9","description":"R9","name":"S9","whybtn":"T9","buttons":"U9"};
    if(module.hot) {
      // 1713211528390
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  